import {PageLayout} from "../../layout/PageLayout/PageLayout";

export const NotAllowedPage = () => {
    return <PageLayout>
        <div>Nema pravo pristupa.</div>
    </PageLayout>
}
